import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DeleteIcon } from 'foundations-assets';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
//@ts-expect-error untyped import
import { updateEncoding } from 'reporting-snowflake/relational/updaters/report';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SnowflakeRemoveConditionalFormattingButton = ({
  report,
  reportDeps,
  onClick,
  selectedColumnName,
  onChange
}) => {
  var _snowflakeRelationalR;
  const snowflakeRelationalReport = createRelationalReportFromBaseReport(report);
  const {
    columns
  } = snowflakeRelationalReport;
  const encodings = (_snowflakeRelationalR = snowflakeRelationalReport.visual) === null || _snowflakeRelationalR === void 0 ? void 0 : _snowflakeRelationalR.encodings;
  const {
    tableDescriptionMeta,
    userInfo
  } = reportDeps;
  const handleColumnChange = dropdownColumn => {
    const column = columns.get(dropdownColumn);
    const encoding = encodings.get('columns').find(encodedColumn => encodedColumn.column === column.get('alias'));
    const index = encodings.get('columns').indexOf(encoding);
    const conditionalFormatting = {
      useConditionalFormatting: false
    };
    const updatedEncoding = encoding.setIn(['options', 'format', 'conditionalFormatting'], conditionalFormatting);
    return updateEncoding(snowflakeRelationalReport, {
      encoding: updatedEncoding,
      toIndex: index,
      channelName: 'columns',
      deps: {
        meta: tableDescriptionMeta,
        userInfo
      }
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: () => {
      const nextReport = handleColumnChange(selectedColumnName);
      onClick(selectedColumnName);
      onChange(nextReport);
    },
    use: "link",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(DeleteIcon, {
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.conditional-formatting.remove-button"
      })]
    })
  });
};